import { BreadcrumbType } from 'types';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

import * as S from './Breadcrumb.styles';

type BreadCrumbProps = {
  breadcrumbs: BreadcrumbType[];
  asSecondaryMotive?: boolean;
};

export function Breadcrumb(props: BreadCrumbProps): React.ReactElement {
  const { breadcrumbs, asSecondaryMotive = false } = props;

  const breadcrumbsIntoComponents = breadcrumbs?.map((item, i) => {
    const label = `${item.label} ${i !== breadcrumbs.length - 1 ? ' /' : ''}`;

    if (item.to) {
      return (
        <Button
          motive={asSecondaryMotive ? 'linkSecondary' : 'default'}
          textTransform="uppercase"
          fontWeight={asSecondaryMotive ? 'light' : 'normal'}
          scale={asSecondaryMotive ? 'xs' : ['xl2', 'xl']}
          fontFamily={asSecondaryMotive ? 'LFT Zeno' : 'LFT Zeno Condensed'}
          key={item.label}
          asLink
          to={item.to}
          isBreadcrumbs
        >
          {label}
        </Button>
      );
    }

    return (
      <Headline
        key={item.label}
        textTransform="uppercase"
        fontWeight={asSecondaryMotive ? 'extraLight' : 'normal'}
        scale={asSecondaryMotive ? 'xs' : ['xl2', 'xl']}
        color={asSecondaryMotive ? 'grayDarkSecondary' : 'blackLight'}
        fontFamily={asSecondaryMotive ? 'LFT Zeno Light' : 'LFT Zeno Condensed'}
        tag={asSecondaryMotive ? 'p' : 'h2'}
      >
        {label}
      </Headline>
    );
  });

  return <S.Container>{breadcrumbsIntoComponents}</S.Container>;
}
